import React from "react";

import { VideosRecordedGraphData } from "@pages/VideoAnalytics/RBTs/GraphAndrawData/VideosRecorded/VideosRecordedGraphData";
import { VideosRecordedRawData } from "@pages/VideoAnalytics/RBTs/GraphAndrawData/VideosRecorded/VideosRecordedRawData";
import { useVideoAnalytics } from "@providers/VideoAnalyticsProvider";

interface VideosRecordedProps {}

export const VideosRecorded: React.FC<VideosRecordedProps> = () => {
  const { selectedDialogTab } = useVideoAnalytics();
  return <div>{selectedDialogTab === "Raw Data" ? <VideosRecordedRawData /> : <VideosRecordedGraphData />}</div>;
};
